import React from 'react';
import './Alert.css';

export interface AlertProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: 'info' | 'warning' | 'danger' | 'success';
  title?: string;
}

export const Alert: React.FC<AlertProps> = ({
  variant = 'info',
  title,
  children,
  className = '',
  ...props
}) => {
  return (
    <div
      className={`sedlex-alert sedlex-alert--${variant} ${className}`}
      role="alert"
      {...props}
    >
      {title && <div className="sedlex-alert__title">{title}</div>}
      <div className="sedlex-alert__body">{children}</div>
    </div>
  );
};
